export const EXTRACTS_PHIN_MISSING_INFORMATION_SEND_TO_SFTP_REQUEST =
	"EXTRACTS_PHIN_MISSING_INFORMATION_SEND_TO_SFTP_REQUEST"
export const EXTRACTS_PHIN_MISSING_INFORMATION_SEND_TO_SFTP_RECEIVE =
	"EXTRACTS_PHIN_MISSING_INFORMATION_SEND_TO_SFTP_RECEIVE"
export const EXTRACTS_PHIN_MISSING_INFORMATION_SEND_TO_SFTP_FAILURE =
	"EXTRACTS_PHIN_MISSING_INFORMATION_SEND_TO_SFTP_FAILURE"

export const EXTRACTS_PHIN_MISSING_INFORMATION_UPLOAD_REQUEST =
	"EXTRACTS_PHIN_MISSING_INFORMATION_UPLOAD_REQUEST"
export const EXTRACTS_PHIN_MISSING_INFORMATION_UPLOAD_RECEIVE =
	"EXTRACTS_PHIN_MISSING_INFORMATION_UPLOAD_RECEIVE"
export const EXTRACTS_PHIN_MISSING_INFORMATION_UPLOAD_FAILURE =
	"EXTRACTS_PHIN_MISSING_INFORMATION_UPLOAD_FAILURE"
